import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';

import workBG from '../../assets/img/project/bg-3-1.jpg';
import workImg1 from '../../assets/img/project/thumb-3-1.png';
import workImg2 from '../../assets/img/project/thumb-3-2.png';
import workImg3 from '../../assets/img/project/thumb-3-3.png';
import workImg4 from '../../assets/img/project/thumb-3-4.png';

const Work = () => {
  const items = [
    {
      numOfWork: '01',
      image: workImg1,
      title: 'Make An appointment',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    },
    {
      numOfWork: '02',
      image: workImg2,
      title: ' Check Your Eye',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    },
    {
      numOfWork: '03',
      image: workImg3,
      title: 'Access report',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    },
    {
      numOfWork: '04',
      image: workImg4,
      title: 'Ongoing Attention',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
    },
  ];

  return (
    <div
      className="it-work-area z-index it-work-bg pt-115 pb-90"
      style={{ backgroundImage: `url(${workBG})` }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <SectionTitle
              itemClass="it-work-title-box text-center mb-70"
              subTitleClass="it-section-subtitle tertiary"
              subTitle="How It works"
              titleClass="it-section-title"
              title="Let's Check Out Our Workflow"
            />
          </div>
        </div>
        <div className="it-work-wrapper p-relative">
          <div className="row">
            {items.map((item) => (
              <div
                key={item.numOfWork}
                className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30"
              >
                <div className="it-work-item text-center">
                  <div className="it-wor-icon-box">
                    <span className="it-work-main-number">
                      {item.numOfWork}
                    </span>
                    <div className="it-work-sub-icon">
                      <span className="download-icon">
                        <svg
                          width="6"
                          height="62"
                          viewBox="0 0 6 62"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 61.5L5.88675 56.5H0.113249L3 61.5ZM2.5 0V1.025H3.5V0H2.5ZM2.5 3.075V5.125H3.5V3.075H2.5ZM2.5 7.175V9.225H3.5V7.175H2.5ZM2.5 11.275V13.325H3.5V11.275H2.5ZM2.5 15.375V17.425H3.5V15.375H2.5ZM2.5 19.475V21.525H3.5V19.475H2.5ZM2.5 23.575V25.625H3.5V23.575H2.5ZM2.5 27.675V29.725H3.5V27.675H2.5ZM2.5 31.775V33.825H3.5V31.775H2.5ZM2.5 35.875V37.925H3.5V35.875H2.5ZM2.5 39.975V42.025H3.5V39.975H2.5ZM2.5 44.075V46.125H3.5V44.075H2.5ZM2.5 48.175V50.225H3.5V48.175H2.5ZM2.5 52.275V54.325H3.5V52.275H2.5ZM2.5 56.375V58.425H3.5V56.375H2.5Z"
                            fill="currentcolor"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className="it-work-content">
                    <div className="it-work-thumb mb-25">
                      <img src={item.image} alt="" />
                    </div>
                    <h3 className="it-work-title mb-15">
                      <Link
                        className="hover-anim white it-work-title-link"
                        to="/portfolio-details"
                      >
                        {item.title}
                      </Link>
                    </h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
